import React, { useContext } from 'react';
import { Helmet } from 'react-helmet-async';
import { LanguageContext } from '../../context/LanguageContext';

interface MetaTagsProps {
  title: {
    pl: string;
    en: string;
  };
  description: {
    pl: string;
    en: string;
  };
  canonicalUrl?: string;
  ogImage?: string;
}

const SEOMetaTags: React.FC<MetaTagsProps> = ({ 
  title, 
  description, 
  canonicalUrl, 
  ogImage = 'https://appotype.eu/static/media/logo-light.cc57704c54d2931f67c2fe720ef0de41.svg'
}) => {
  const languageContext = useContext(LanguageContext);
  const language = languageContext?.language || 'pl';

  // Get the current values based on language
  const currentTitle = language === 'pl' ? title.pl : title.en;
  const currentDescription = language === 'pl' ? description.pl : description.en;
  
  // Get full canonical URL
  const siteUrl = 'https://appotype.eu';
  const fullCanonicalUrl = canonicalUrl ? `${siteUrl}${canonicalUrl}` : siteUrl;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{currentTitle}</title>
      <meta name="description" content={currentDescription} />
      <meta name="language" content={language} />
      
      {/* Canonical Link */}
      <link rel="canonical" href={fullCanonicalUrl} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={fullCanonicalUrl} />
      <meta property="og:title" content={currentTitle} />
      <meta property="og:description" content={currentDescription} />
      <meta property="og:image" content={ogImage} />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={fullCanonicalUrl} />
      <meta property="twitter:title" content={currentTitle} />
      <meta property="twitter:description" content={currentDescription} />
      <meta property="twitter:image" content={ogImage} />
      
      {/* Set language attribute on html tag */}
      <html lang={language} />
    </Helmet>
  );
};

export default SEOMetaTags; 